import React from 'react';
import ValidatedInput from '../TextInput/ValidatedInput';
import './passwordinput.scss';
import see from '../../../assets/images/see.svg'
import hide from '../../../assets/images/unsee.svg'

/** @import { PasswordWithConfirmationInputProps, PasswordWithConfirmationInputState } from './PasswordWithConfirmationInputTypes' */

/** @extends ValidatedInput<PasswordWithConfirmationInputProps> */
class PasswordWithConfirmationInput extends ValidatedInput {
    /** @type {PasswordWithConfirmationInputState} */
    state = { value: '' };

    /** @type {React.RefObject<HTMLInputElement>} */
    confirmPasswordRef = React.createRef();

    /** @type {React.RefObject<HTMLInputElement>} */
    passwordRef = React.createRef();

    constructor(/** @type {PasswordWithConfirmationInputProps} */ props) {
        super(props);

        this.state = {
            passwordShowing: false,
            confirmPasswordShowing: false,
            showConfirmPassword: false,
            isMatch: false
        };
    }

    toggleSee(/** @type {string} */ inputType) {
        if(inputType === "password")
            this.setState({passwordShowing: !this.state.passwordShowing});
        else if (inputType === "confirmPassword")
            this.setState({confirmPasswordShowing: !this.state.confirmPasswordShowing});
    }

    handleOnChangePassword = (/** @type {React.ChangeEvent<HTMLInputElement>} */ e) => {
        const {value} = e.target;

        // call to superclass' change handler, without it firing onChange handler
        //this.handleChange(e, true);

        let results = this.testAllRules(value);
        this.setState({
            ...results.validationResults
        }, () => {
            // this is necessary to evaluate the latest props.validationErrors from the onChange above
            let reevaluatedResults = this.testAllRules(value);

            if (reevaluatedResults.allValid) {
                this.setState({ showConfirmPassword: reevaluatedResults.allValid }, ()=>{
                    const confirmPasswordValue = this.confirmPasswordRef.current ? this.confirmPasswordRef.current.value : '';
                    const isMatch = value === confirmPasswordValue;
                    this.setState({isMatch : (value === confirmPasswordValue)})
                    this.props.onChangeWithMatch && this.props.onChangeWithMatch(isMatch, value);
                });
            } else {
                this.setState({ showConfirmPassword: reevaluatedResults.allValid });
                this.props.onChangeWithMatch && this.props.onChangeWithMatch(false, value);
            }
        });
    }

    handleOnChangeConfirmPassword = (/** @type {React.ChangeEvent<HTMLInputElement>} */ e) => {
        const confirmPassword = e.target.value;
        const password = this.passwordRef.current ? this.passwordRef.current.value : '';
        const isMatch = (password === confirmPassword);

        this.setState({isMatch : (password === confirmPassword)});
        this.props.onChangeWithMatch && this.props.onChangeWithMatch(isMatch,password);
    };

    renderConfirmPasswordValidations() {
        //if (this.props.alwaysShowValidations === false) return;
        let showRules = this.props.alwaysShowValidations;
        return showRules && (
            <ul className='validated-input__validations'>
                <li key={'PasswordsMustMatch'} className= {`validation-rule ${this.state.isMatch ? 'validation-rule--pass' : ''}`}>
                    Passwords must match
                </li>
            </ul>
        );
    }

    render() {
        return (
            <>
                <div className="password-input">
                    <input
                        name={this.props.name}
                        className={this.getInputClassNames()}
                        type={this.state.passwordShowing ? "text" : "password"}
                        placeholder={this.props.placeholder}
                        onChange={this.handleOnChangePassword}
                        disabled={this.props.disabled}
                        ref={this.passwordRef}
                        data-test={this.props.name}
                    />
                    <div className='password-input__showhide' onClick={() => this.toggleSee("password")}>
                        <img alt="toggle password visibility"
                             className={this.state.passwordShowing ? 'password-input__showhide--showing' : ''}
                             src={this.state.passwordShowing ? hide : see}/>
                    </div>
                    {this.renderValidations()}
                    {
                        this.state.showConfirmPassword && (
                            <div className="password-input">
                                <input
                                    name="confirm-password"
                                    className={this.getInputClassNames()}
                                    type={this.state.confirmPasswordShowing ? "text" : "password"}
                                    placeholder="Confirm Password"
                                    onChange={this.handleOnChangeConfirmPassword}
                                    disabled={this.props.disabled}
                                    ref={this.confirmPasswordRef}
                                    data-test="confirm-password"
                                />
                                <div className='password-input__showhide' onClick={() => this.toggleSee("confirmPassword")}>
                                    <img alt="toggle password visibility"
                                         className={this.state.confirmPasswordShowing ? 'password-input__showhide--showing' : ''}
                                         src={this.state.confirmPasswordShowing ? hide : see}/>
                                </div>
                                {this.renderConfirmPasswordValidations()}
                            </div>
                        )
                    }
                </div>
            </>
        );
    }
}

export default PasswordWithConfirmationInput;
